import { Pagination } from "pepsico-ds";
import { useContext, useEffect, useMemo, useState } from "react";

import { listHistoryLogs } from "../../../graphql/queries/listHistoryLogs";
import {
  ListingComponentContext,
  ListingComponentProvider,
} from "../../common/listingComponents/ListingComponentContext";
import ListingComponentWrapper from "../../common/listingComponents/ListingComponentWrapper";
import CampaignTable from "./CampaignTable";
import "./CampaignTable.scss";
import {
  configurationFilterJsonSchema,
  configurationFilterUiSchema,
  debounceFilterJsonSchema,
  debounceFilterUiSchema,
} from "./mocks";

const ConfigurationTab = () => {
  return <ConfigurationTabWithPagination />;
};

const ConfigurationTabWithPagination = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  // Calculate offset for current page
  const offset = (currentPage - 1) * pageSize;

  return (
    <ListingComponentProvider
      query={listHistoryLogs}
      fetchPolicy="cache-and-network"
      queryKey="listHistoryLogs"
      initialFilterData={{
        type: "configuration",
        showDiff: true,
      }}
      extraVariables={{
        offset: offset,
        limit: pageSize,
      }}
      noPagination={true}
    >
      <ConfigurationListLog
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
      />
    </ListingComponentProvider>
  );
};

const ConfigurationListLog = ({ currentPage, setCurrentPage, pageSize }) => {
  const { setFilterData, viewableRecords } = useContext(ListingComponentContext);

  useEffect(() => {
    setFilterData((prev) => ({
      ...prev,
    }));
  }, [setFilterData]);

  // Get data from API response
  const filteredData = useMemo(() => {
    return viewableRecords?.items || [];
  }, [viewableRecords?.items]);

  // Calculate total pages from API response
  const totalPages = Math.ceil((viewableRecords?.total || 0) / pageSize);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="px-3 pt-3">
      <div className="container-card">
        <div className="page-content">
          <ListingComponentWrapper
            customStyles={{ flex: 1 }}
            filterClasses="filter-styles"
            offsetBasedPagination={false}
            filterConfig={{
              withDebounce: {
                jsonSchema: debounceFilterJsonSchema,
                uiSchema: debounceFilterUiSchema,
              },
              withoutDebounce: {
                jsonSchema: configurationFilterJsonSchema,
                uiSchema: configurationFilterUiSchema,
              },
            }}
            toggleViewType={false}
            showAllFiltersOption={true}
            enableAllFiltersButton={false}
          >
            <CampaignTable data={filteredData} source="configuration" />
            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                onUpdate={handlePageChange}
                pageCount={totalPages}
                size="medium"
                variant="number"
              />
            )}
          </ListingComponentWrapper>
        </div>
      </div>
    </div>
  );
};

export { ConfigurationListLog };
export default ConfigurationTab;
